<cv-generic-export [items]="items" [fileName]="getLocalizationString('Usage_Stats_Breakdown', 'Usage Stats Breakdown') + ' '"></cv-generic-export>
